module.exports = __webpack_public_path__ + "static/media/reg2_ic.a738e4c1.svg";